import Toggle from 'toggle/Toggle';
import Trigger from 'toggle/Trigger';
import Collapsible from 'ui/Collapsible';
import scrollTo from 'utils/scrollTo';
import Observer from 'utils/Observer';
import DOMHelper from 'utils/DOMHelpers';

/**
 * Default values for attribute and states.
 * @constant
 */
const TRIGGER_METHOD = 'switch';
const TOGGLE_TYPE = 'Toggle';
const TYPES = {
    Toggle: Toggle,
    Collapsible: Collapsible
};

/**
 * Class ToggleGroup that handles base functionality for ToggleGroups like Tabs and Accordions.
 * @class
 */
class ToggleGroup {
    /**
     * Make a new ToggleGroup.
     * @constructs
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._initialize();
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {

        // collect the dom elements and options
        let triggerElements = document.querySelectorAll(this._options.triggerSelector);
        let panelElements = document.querySelectorAll(this._options.panelSelector);
        let triggerMethod = this._options.triggerMethod || TRIGGER_METHOD;
        let toggleType = this._options.toggleType || TOGGLE_TYPE;
        let id = this._element.id || '';
        let i = 0;
        let l = triggerElements.length;
        let panelElement;
        let triggerElement;
        let trigger;

        for (; i < l; i++) {

            panelElement = panelElements[i];
            triggerElement = triggerElements[i];

            // check if the elements are containing ids
            this._checkId(panelElement, 'panel', i);
            this._checkId(triggerElement, 'trigger', i);

            // create instances for triggers and toggles according to the options
            new TYPES[toggleType](panelElement, {
                group: `${id}-group`,
                attribute: 'aria-hidden',
                activeState: 'false',
                inActiveState: 'true'
            });
            trigger = new Trigger(triggerElement, {
                targets: panelElement.id,
                group: `${id}-panel-group`,
                attribute: 'aria-selected',
                method: triggerMethod,
                toggle: 'true'
            });

            if (this._options.scrollto === true) {
                Observer.subscribe(trigger._toggle, trigger._toggle.activeEvent, this._onTriggerActivated.bind(this));
            }
        }

    }


    /**
     * Check if the element contains an id otherwise create and set one.
     * @param {HTMLElement} element - The HTMLElement
     * @param {String} addition - additional suffix
     * @param {Int} index - A number
     * @private
     */
    _checkId(element, addition, index) {
        if (!element.id) {
            element.id = `${this._element.id}-${addition}-${index}`;
        }
    }


    /**
     * On Trigger activated handler
     * @param {Object} trigger - the trigger object
     * @private
     */
    _onTriggerActivated(trigger) {
        setTimeout(() => {
            scrollTo(window, DOMHelper.getPosition(trigger._element) - 30);
        }, 350);
    }
}

export default ToggleGroup;
